import React, { useEffect } from 'react';
import { X, Phone, Mail } from 'lucide-react';
import { IMPRESSUM } from '../mock';

export default function Impressum({ open, onClose }) {
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    const onKey = (e) => e.key === 'Escape' && onClose();
    if (open) window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] bg-[#0c0a08]/95 backdrop-blur-sm flex items-center justify-center px-5 py-10"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-lg rounded-2xl border border-[rgba(224,180,159,0.2)] bg-[#17130f] p-8 md:p-10 max-h-[85vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-5 right-5 flex items-center justify-center h-9 w-9 rounded-full border border-[rgba(224,180,159,0.3)] text-[#f2ebe3] hover:bg-[#e0b49f] hover:text-[#1a1410] hover:border-[#e0b49f] transition-all duration-300"
          aria-label="Schließen"
        >
          <X size={18} />
        </button>

        <span className="eyebrow">Rechtliches</span>
        <h2 className="mt-2 font-serif-display text-3xl md:text-4xl text-[#f2ebe3]">Impressum</h2>

        <div className="mt-8 space-y-6 text-[#c3b7aa] leading-relaxed">
          <div>
            <h3 className="text-[#e0b49f] text-sm uppercase tracking-[0.16em] mb-2">Angaben gemäß § 5 TMG</h3>
            <p className="text-[#f2ebe3] font-medium">{IMPRESSUM.company}</p>
            <p>Inhaberin: {IMPRESSUM.owner}</p>
            <p>{IMPRESSUM.street}</p>
            <p>{IMPRESSUM.city}</p>
            <p>{IMPRESSUM.country}</p>
          </div>

          <div>
            <h3 className="text-[#e0b49f] text-sm uppercase tracking-[0.16em] mb-2">Kontakt</h3>
            <a href={IMPRESSUM.phoneHref} className="flex items-center gap-2.5 hover:text-[#e0b49f] transition-colors">
              <Phone size={15} /> {IMPRESSUM.phone}
            </a>
            <a href={`mailto:${IMPRESSUM.email}`} className="mt-1.5 flex items-center gap-2.5 hover:text-[#e0b49f] transition-colors">
              <Mail size={15} /> {IMPRESSUM.email}
            </a>
          </div>

          <div>
            <h3 className="text-[#e0b49f] text-sm uppercase tracking-[0.16em] mb-2">Umsatzsteuer-ID</h3>
            <p>Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:</p>
            <p className="text-[#f2ebe3] font-medium">{IMPRESSUM.vat}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
